const ButtonIcon = ({ title, icon, children, ...rest }) => {
  return (
    <button {...rest}>
      {icon} {title} {children}
    </button>
  );
};

export default ButtonIcon;
